enum OrderStatus {
  INVISIBLE = 5,
  NOT_GIVEN = 10,
  APPROVED = 80,
  REFUSED = 99,
}

export default OrderStatus;

export const APPROVAL_ORDER_STATUSES = [OrderStatus.APPROVED, OrderStatus.REFUSED];